module.exports = __webpack_public_path__ + "media/src/application/media/img/grey_wash_wall-8092d80b498486b8742fb52bf919395f.jpg";